import { Col, Row } from 'antd';
import classNames from 'classnames';
import { map } from 'lodash-es';
import { FormattedMessage } from 'react-intl';

import {
  extractBilledWeight,
  getPackageTotal,
} from '../../forms/shipments/shipmentCommon';
import { capitalizeWords } from '../../common/utils/stringUtils';
import { YesNoFormat } from '../../components/forms/checkable';
import { TwoLinesSeparator } from '../../components/layout/layoutElements';
import { WeightFormat } from '../../components/domainSpecific/measuringUnitsElements';
import { useQuoteSummaryOverviewStyles } from './QuoteSummaryOverview.styles';

const QuoteSummaryOverview = ({ quote }) => {
  const { styles } = useQuoteSummaryOverviewStyles();
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col className={styles.detailsGridItem} lg={8} xl={6}>
          <span className={styles.labelFirst}>
            <FormattedMessage id="shipmentDetail.service" />
          </span>
          <span className={styles.value}>{quote?.serviceType?.text}</span>
        </Col>
        <Col className={styles.detailsGridItem} lg={16} xl={9}>
          <span className={styles.labelSecond}>
            <FormattedMessage id="book.newShipment.label.commodity" />
          </span>
          <span className={styles.value}>
            {capitalizeWords(quote?.commodity)}
          </span>
        </Col>
        <Col
          className={classNames(styles.detailsGridItem, 'hide-lg-and-smaller')}
          lg={8}
          xl={9}
        >
          <span className={styles.labelLast}>
            <FormattedMessage id="book.newQuote.dg-long" />
          </span>
          <span className={styles.value}>
            <YesNoFormat value={!!quote?.dangerousGoods} />
          </span>
        </Col>
      </Row>
      <TwoLinesSeparator className="full-width-separator" />

      <Row gutter={[16, 16]}>
        <Col className={styles.detailsGridItem} span={8} xl={6}>
          <span className={styles.labelFirst}>
            <FormattedMessage id="quoteDetail.pieces" />
          </span>
          <span className={styles.value}>{quote?.pieces}</span>
        </Col>
        <Col className={styles.detailsGridItem} lg={16} xl={9}>
          <span className={styles.labelSecond}>
            <FormattedMessage id="quoteDetail.billWeight" />
          </span>
          <span className={styles.value}>
            <WeightFormat
              value={getPackageTotal(quote?.packages, extractBilledWeight)}
            />
          </span>
        </Col>
        <Col
          className={classNames(styles.detailsGridItem, 'hide-lg-and-smaller')}
          xl={9}
        >
          <span className={styles.labelLast}>
            <FormattedMessage id="book.newQuote.excepted-quantity" />
          </span>
          <span className={styles.value}>
            {quote?.dangerousGoods ? (
              <YesNoFormat value={quote?.exceptedQty} />
            ) : (
              <FormattedMessage id="labels.na" />
            )}
          </span>
        </Col>
      </Row>
      <TwoLinesSeparator className="full-width-separator" />
    </>
  );
};

export const QuoteSummaryOverviewSmall = ({ quote }) => {
  const { styles } = useQuoteSummaryOverviewStyles();
  return (
    <>
      <Row>
        <Col span={24}>
          <TwoLinesSeparator className="full-width-separator" />
        </Col>
      </Row>
      <Row gutter={[0, 16]}>
        <Col className={styles.detailsGridItemSmall} span={12}>
          <span className={styles.labelFirstSmall}>
            <FormattedMessage id="shipmentDetail.service" />
          </span>
          <span className={styles.valueSmall}>{quote?.serviceType?.text}</span>
        </Col>
        <Col className={styles.detailsGridItemSecondSmall} span={12}>
          <span className={styles.labelSecondSmall}>
            <FormattedMessage id="shipmentDetail.comodity" />
          </span>
          <span className={styles.valueSecondSmall}>
            {capitalizeWords(quote?.commodity)}
          </span>
        </Col>

        <Col className={styles.detailsGridItemSmall} span={12}>
          <span className={styles.labelFirstSmall}>
            <FormattedMessage id="quoteDetail.pieces" />
          </span>
          <span className={styles.valueSmall}>{quote?.pieces}</span>
        </Col>
        <Col className={styles.detailsGridItemSecondSmall} span={12}>
          <span className={styles.labelSecondSmall}>
            <FormattedMessage id="shipmentDetail.weight" />
          </span>
          <span className={styles.valueSecondSmall}>
            <WeightFormat
              value={getPackageTotal(quote?.packages, extractBilledWeight)}
            />
          </span>
        </Col>

        <Col className={styles.detailsGridItemSmall} span={12}>
          <span className={styles.labelFirstSmall}>
            <FormattedMessage id="book.newQuote.dg" />
          </span>
          <span className={styles.valueSmall}>
            <YesNoFormat value={quote?.dangerousGoods} />
          </span>
        </Col>
        {quote?.dangerousGoods && (
          <Col className={styles.detailsGridItemSecondSmall} span={12}>
            <span className={styles.labelSecondSmall}>
              <FormattedMessage id="quoteDetail.unNumber.short" />
            </span>
            <span className={styles.valueSecondSmall}>
              {map(quote?.unNumber, ({ code }) => (
                <p>{code}</p>
              ))}
            </span>
          </Col>
        )}
      </Row>
    </>
  );
};

export default QuoteSummaryOverview;
